<script setup lang="ts">
//#region imports
import UiDropdownSelect from '@/views/CRM/components/UiDropdownSelect.vue';
import UiChevron from '@/views/CRM/components/UiChevron.vue';
//#endregion

//#region types
interface MessageParam {
  param: string;
  label: string;
}

interface Props {
  disabled?: boolean;
  messageParams?: MessageParam[];
}

interface Emits {
  select: [payload: string];
}
//#endregion

//#region define
withDefaults(defineProps<Props>(), {
  disabled: false,
  messageParams: () => [],
});

const emit = defineEmits<Emits>();
//#endregion

//#region methods
function handleSelect(payload: string) {
  emit('select', payload);
}
//#endregion
</script>

<template>
  <UiDropdownSelect
    :items="messageParams"
    :search-placeholder="$t('crm.activities.actions.action_params_popup.search_placeholder')"
    :not-found-message="$t('crm.activities.actions.action_params_popup.not_found')"
    :disabled="disabled"
    @select="handleSelect"
  >
    <template v-slot:activator="slotProps">
      <UiButton
        icon="globe"
        :filled="slotProps.active"
        :disabled="disabled"
      >
        {{ $t('crm.activities.actions.action_params_popup.title') }}
        <UiChevron
          class="crm-action-params__chevron"
          :rotate="!slotProps.active"
        />
      </UiButton>
    </template>
  </UiDropdownSelect>
</template>

<style lang="scss">
  .crm-action-params {
    &__chevron {
      margin-left: 4px;
      line-height: 12.5px;
    }
  }
</style>
